import script from "./IlanlarScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./IlanlarScreen.vue?vue&type=script&setup=true&lang=js"

import "./IlanlarScreen.vue?vue&type=style&index=0&id=615820de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615820de"]])

export default __exports__